module.exports = __webpack_public_path__ + "static/feature-3-2640c62db6c591e08841df21e82c98bd.svg";